import { render, staticRenderFns } from "./PayCollect.vue?vue&type=template&id=55c57266&scoped=true&"
import script from "./PayCollect.vue?vue&type=script&lang=js&"
export * from "./PayCollect.vue?vue&type=script&lang=js&"
import style0 from "./PayCollect.vue?vue&type=style&index=0&id=55c57266&prod&lang=scss&scoped=true&"
import style1 from "./PayCollect.vue?vue&type=style&index=1&id=55c57266&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c57266",
  null
  
)

export default component.exports